import { SAVE_POSITION_TOKEN, REMOVE_POSITION_TOKEN } from '../../util/actionTypes';

const initialState ={
    token: "",
  
};

const positionTokenReducer = (state =initialState, action) => {
    switch (action.type) {
   
        case SAVE_POSITION_TOKEN: 
            return {
                ...state,
                ...action.payload, 
              };     
  
        default:
            return state;
    }
};

export default positionTokenReducer;
